import { createFileRoute } from '@tanstack/react-router'

import { BrandCampaignLanding, brandCampaignHead, loadBrandCampaign } from '../components/BrandCampaignLanding'
import { getBrandCampaign } from '../data/brandCampaigns'

const campaign = getBrandCampaign('cd-salyna')!

export const Route = createFileRoute('/cd-salyna')({
  loader: () => loadBrandCampaign(campaign),
  head: () => brandCampaignHead(campaign),
  component: CdSalynaPage,
})

function CdSalynaPage() {
  return <BrandCampaignLanding data={{ ...Route.useLoaderData(), campaign }} />
}
